/* ===========================================================================
   Forever Hungry — early-access drop countdown.
   Loaded deferred by layout/early-access.liquid. Owns ONLY the ticking clock.

   It does NOT own the initial pre-vs-live decision — that is made pre-paint by
   the tiny inline bootstrap at the top of sections/fh-early-access.liquid, so a
   visitor arriving after the drop never sees a flash of the countdown. Both
   scripts read the same single source of truth: data-fh-drop-at on the section
   root. There is no second copy of the drop time anywhere.
   =========================================================================== */
(function () {
  'use strict';

  var stage = document.querySelector('[data-fh-drop-at]');
  if (!stage) return;

  var target = Date.parse(stage.getAttribute('data-fh-drop-at'));
  if (isNaN(target)) return;   // malformed date: leave the pre-drop markup as served

  var d = stage.querySelector('[data-fh-d]'),
      h = stage.querySelector('[data-fh-h]'),
      m = stage.querySelector('[data-fh-m]'),
      s = stage.querySelector('[data-fh-s]');
  if (!d || !h || !m || !s) return;

  var timer = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function paint() {
    var left = target - Date.now();

    if (left <= 0) {
      stage.setAttribute('data-fh-drop-state', 'live');
      if (timer) { clearInterval(timer); timer = null; }
      return;
    }

    var sec = Math.floor(left / 1000);
    // Days are deliberately not clamped to two digits — a 100+ day countdown
    // must still tell the truth rather than wrap.
    d.textContent = pad(Math.floor(sec / 86400));
    h.textContent = pad(Math.floor(sec / 3600) % 24);
    m.textContent = pad(Math.floor(sec / 60) % 60);
    s.textContent = pad(sec % 60);

    stage.setAttribute('data-fh-hydrated', '');
  }

  paint();
  if (Date.now() < target) timer = setInterval(paint, 1000);

  // Browsers throttle setInterval in a backgrounded tab, so a phone that has
  // been in a pocket comes back showing a stale time. Recompute on return —
  // and flip to the live state if the drop happened while it was hidden.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) paint();
  });
})();
